import { motion } from "framer-motion";
import { SplitReveal } from "../components/SplitReveal";
import { useLanguage } from "../lib/i18n";
import { usePrefersReducedMotion } from "../lib/useReducedMotion";

// SÜREÇ — vertical orange line fills as steps enter the viewport.
export function Process() {
  const { t } = useLanguage();
  const reduced = usePrefersReducedMotion();
  const steps = t.process.steps;

  return (
    <section className="relative bg-[#08090B] px-6 py-24 md:px-12 md:py-40" data-testid="process-section">
      <div className="mx-auto max-w-4xl">
        <div className="mb-16 text-center">
          <p className="heading mb-4 text-sm not-italic tracking-[0.3em] text-hars-orange">{t.process.kicker}</p>
          <SplitReveal text={t.process.title} className="heading text-4xl text-white md:text-6xl" />
        </div>

        <div className="relative pl-10 md:pl-0">
          {/* center line */}
          <div className="absolute left-3 top-0 h-full w-px bg-white/10 md:left-1/2" />
          <motion.div
            className="absolute left-3 top-0 w-px origin-top bg-hars-orange md:left-1/2"
            initial={{ scaleY: 0 }}
            whileInView={{ scaleY: 1 }}
            viewport={{ once: true, margin: "-20%" }}
            transition={{ duration: 1.4, ease: "easeInOut" }}
            style={{ height: "100%" }}
          />

          <div className="space-y-14">
            {steps.map((s, i) => (
              <motion.div
                key={i}
                data-testid={`process-step-${i}`}
                initial={reduced ? false : { opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-15%" }}
                transition={{ duration: 0.6, delay: 0.05 }}
                className={`relative md:flex md:items-center md:gap-8 ${i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}
              >
                <div className={`md:w-1/2 ${i % 2 === 0 ? "md:text-right md:pr-8" : "md:pl-8"}`}>
                  <span className="heading text-5xl text-hars-orange/30">0{i + 1}</span>
                  <h3 className="heading -mt-4 text-2xl text-white">{s.t}</h3>
                  <p className="mt-2 font-inter text-sm text-hars-muted">{s.d}</p>
                </div>
                <div className="absolute -left-[34px] top-1 h-4 w-4 rounded-full border-2 border-hars-orange bg-[#08090B] md:static md:mx-auto" />
                <div className="hidden md:block md:w-1/2" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
